<template>
  <div>
    <md-card class="box-card" style="overflow: visible;position: unset">
      <md-card-header 
        class="md-card-header-text md-card-header-green" 
        style="margin-right: 0;"
        v-if="this.dataShowSubscript === null || this.dataShowSubscript">
          <div class="search-header" v-if="themeObj.dataTitleShow == true">
            <div v-if="themeObj.dataTitleType == 'text'">
              <span>{{dataTitle ? dataTitle : $route.name}}</span>
              <slot name="search-header"></slot>
            </div>
            <div v-else class="card-icon" :style="iconStyle">
              <md-icon md-src="/static/svg/form.svg"></md-icon>
            </div>
            <div>
              <i class="el-icon-d-caret" @click="show"></i>
            </div>
          </div>

        </md-card-header>

      <div slot="header" class="clearfix" style="text-align:right">

      </div>

      <div :class="themeObj.dataTitleShow == true ? '' : 'k-form-search-box'">
        <div class="show-form" id="show-form">
          <k-form 
          ref="searchForm" 
          :data-col="0" 
          :data-ui="themeObj.dataTitleShow == true ? '' : 'element'" >
            <slot></slot>
          </k-form>
        </div>

        <div 
        class="k-form-search-footer" 
        :class="themeObj.dataTitleShow == true  
          ? '' : 'k-form-search-footer-abs'" 
        v-if="themeObj.dataBtnType == 'kayakTheme'">
          <k-btn class="btn-primary btn-border" :data-handler="query" data-size="primary">
            确定
          </k-btn>
          <!-- <k-btn class="btn-info btn-border" data-functype="RESET" data-type="warning" data-from="searchForm" data-size="primary">
            重置
          </k-btn> -->
          <k-btn 
          :data-show-icon="true"
          class="btn-info btn-border" 
          data-type="warning" 
          data-size="primary"
          data-functype="POPUP"
          data-target="dialog">
            展开
            <i class="el-icon-caret-bottom"></i>
          </k-btn>
          <div class="my-el-icon-box"> 
              <i class="el-icon-d-caret" @click="show"></i>
            </div>
          <slot  name="button"></slot>
        </div>

        <div class="k-form-search-footer" v-else>
          <k-btn class="md-success" :data-handler="query">
            <md-icon md-src="/static/svg/search.svg"></md-icon>查询
          </k-btn>
          <k-btn class="md-info" data-functype="RESET" data-type="warning" data-from="searchForm">
            <md-icon md-src="/static/svg/reset.svg"></md-icon>重置
          </k-btn>
          <slot  name="button"></slot>
        </div>
      </div>
    </md-card>
    <!-- <k-popup  data-width-percent="40%" ref="dialog" data-title="动态搜索" :data-mask="true" :data-confirm-close="false" data-confirm-describe="是否关闭弹出框"
        data-title-align="center" data-type="drawer">
        <k-form dataTotalWidth="auto" :data-col="1" :data-model="formData">
          <k-form-item  label="查询条件" data-ui="element">
            <k-field-checkbox v-model="formData.selectValue" :data-data="this.list" data-display-field="label"
              data-value-field="label" :data-multiple="true"></k-field-checkbox>
          </k-form-item>
          <k-form-footer  dataAlign="center">
            <k-btn class="md-primary" data-functype="CLOSE" data-type="primary" :dataHandler="()=>dataConfirm()">
              保存
            </k-btn>
            <k-btn class="md-info" data-functype="CLOSE">
              关闭
            </k-btn>
          </k-form-footer>
        </k-form>
      </k-popup> -->
    </div>
</template>

<script>
  import KBtn from "../k-btn/k-btn";
  import emitter from "@/components/k-element/common/k-emitter.js";
  import props from "@/components/k-element/common/k-field-props.js";
  import kTheme from "@/components/k-element/common/k-theme.js";

  import { KFormSearchCustomizeDefaultProps } from "@/components/k-element-default-config/defaultConfig.js";

  export default {
    name: 'kFormSearchCustomize',
    mixins: [props(), emitter(), kTheme()],
    components: {
      KBtn
    },
    props: {
      dataTitle: {
        type: String
      },
      dataTarget: {
        type: String
      },
      dataTitleShow: {
        type:Boolean
      },
    },
     created () {
      // 字段配置赋值
      this.setDefaultConfig(KFormSearchCustomizeDefaultProps)
    },
    data() {
      return {
        extends: true,
      }
    },
    computed: {
      iconStyle() {
        let iconStyle = {};
        iconStyle.background = this.$store.state.system.cardBackground
        return iconStyle;
      }
    },
    methods: {
      show() {
        let e = document.getElementById('show-form')
        if (this.extends) {
          e.style.display = "none"
        } else {
          e.style.display = ""
        }
        this.extends = !this.extends
      },
      query() {
        this.$emit("click")
        if (!this.dataTarget) {
          console.error("k-from-search需要指定data-target.")
        }
        let target = this.getParentRef(this.dataTarget);
        if (target && target.$options.name === "KGrid") {
          let params = {};

          for (let field in this.value) {
            let valueElement = this.value[field];
            if (valueElement) {
              params[field] = valueElement;
            }
          }

          let re = this.$refs.searchForm.validate();
          if (re === false) {
            return;
          }

          target.load(params)
        } else if(target && target.$options.name === "KReport"){
          let params = {};

          for (let field in this.value) {
            let valueElement = this.value[field];
            if (valueElement) {
              params[field] = valueElement;
            }
          }

          let re = this.$refs.searchForm.validate();
          if (re === false) {
            return;
          }

          this.$emit("loadDataForTable",params)
        } else {
          console.error("data-target不存在或data-target不是KGrid组件.")
        }
      },
      show() {
        let e = document.getElementById('show-form')
        if (this.extends) {
          e.style.display = "none"
        } else {
          e.style.display = ""
        }
        this.extends = !this.extends
      },

    }

  }
</script>

<style lang="scss">
  @import './k-form-search.scss';
</style>



// WEBPACK FOOTER //
// src/components/k-element/k-form-search/k-form-search-customize.vue